import { Label, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import { IPromoInfo } from 'shared/types/newbuildingPromos';

import * as styles from './styles.css';

interface IPromoItemProps {
  promo: IPromoInfo;
  icon: React.ReactNode;
  subtitle: React.ReactNode;
  onClick(): void;
  isMainDiscountPromo?: boolean;
}

export function PromoItem(props: IPromoItemProps) {
  const { promo, onClick, icon, subtitle, isMainDiscountPromo } = props;
  const { name, isBlackFriday } = promo;

  return (
    <div className={styles['container']} onClick={onClick} data-testid={'PromoItem'}>
      <div className={styles['icon-wrapper']}>
        <div className={styles['icon']}>{icon}</div>
      </div>
      <div className={styles['description']}>
        <div className={styles['title']}>
          <UIHeading4 as="h4">{name}</UIHeading4>
        </div>
        <div className={styles['subtitle']}>
          {isMainDiscountPromo && (
            <Label background="accent-positive-primary" color="decorative-theme-white">
              Выгодно
            </Label>
          )}
          {isBlackFriday && (
            <Label background="accent-main-primary" color="decorative-theme-white">
              Sale
            </Label>
          )}
          {subtitle}
        </div>
      </div>
    </div>
  );
}
